import { Property } from '@square/ignition';
// TODO: Move PropertyInfo into a shared UI component
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PropertyInfo } from '@squareup/dex-tech-reference-properties';
import { ApiReferenceFieldName } from '@squareup/dex-ui-shared-api-reference';
import { Box, BoxProps } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FC, ReactNode, memo } from 'react';

import styles from './api-explorer-field.module.css';

interface Props {
  preChildren?: React.ReactNode;
  postChildren?: React.ReactNode;
  property?: Property | undefined;
  name?: string | undefined;
  typeField?: ReactNode | undefined;
}

const ApiExplorerFieldLabel: FC<Props & Pick<BoxProps, 'margin'>> = memo(
  ({ preChildren, postChildren, property, name, typeField, margin }) => {
    if (property) {
      return (
        <PropertyInfo
          property={property}
          category={0}
          disableAnchor={true}
          narrowView={true}
          preChildren={preChildren}
          postChildren={postChildren}
          className={styles['field-info']}
          margin={{ bottom: '1x' }}
          showTooltip
        />
      );
    } else {
      return (
        <Box
          className={clsx(styles['name-label'], styles['field-info'])}
          margin={margin}
        >
          {preChildren}
          <ApiReferenceFieldName name={name || ''} />
          {typeField}
          {postChildren}
        </Box>
      );
    }
  }
);

ApiExplorerFieldLabel.displayName = 'ApiExplorerFieldLabel';

export { ApiExplorerFieldLabel };
